// Text and accent colours shared by the inline styles of the table rows and the
// stock profile (issue #445). Inline because the prebuilt tailwind-output.css
// lacks text-gray-400/500 and friends — a class that was never generated fails
// silently (CLAUDE.md).

export const TEXT_MUTED = '#9ca3af';   // tertiary: chips, captions, "est."
export const TEXT_SUBTLE = '#6b7280';  // secondary labels
export const TEXT_BODY = '#4b5563';    // sub-lines under a value
export const ACCENT = '#6366f1';       // section icons, favourable score bars

const UP = '#16a34a';
const DOWN = '#dc2626';

// Green for a rise, red for a fall. Only call it with a real number — a null
// reads as >= 0 in JS and would paint absence green (CLAUDE.md).
export const signColor = (value) => (value >= 0 ? UP : DOWN);
